import { forwardRef, useImperativeHandle, useRef } from 'react';

//* Components
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import Image from 'components/common/Image';
import RunningText from '../RunningText';

//* Style
import DistributorsSectionStyle from './style';

const DistributorsSection = forwardRef(({ title, distributors, image }, ref) => {
	//! Refs
	const titleRef = useRef();
	const imageRef = useRef();

	useImperativeHandle(ref, () => ({
		imageRef: imageRef.current,
		titleRef: titleRef.current,
	}));

	return (
		<DistributorsSectionStyle className='ds-container'>
			<Text
				tag={`h2`}
				ref={titleRef}
				className={`h4 minion3-medium primary-color9 uppercase align-center ds-title`}
				text={title}
			/>

			<div
				className={`ds-map-wrapper relative`}
				ref={imageRef}>
				<Image
					src={image?.src}
					alt={image?.alt}
					className={'contain'}
				/>

				<div className={`absolute-wrapper`}>
					<RunningText arr={distributors} />
				</div>
			</div>

			<div className={`m-btn-wrap`}>
				<Button
					text={`exploreDistributors`}
					url={`/distributors`}
				/>
			</div>
		</DistributorsSectionStyle>
	);
});

export default DistributorsSection;
